// src/utils/mediaUrl.js
/**
 * Get full media URL for uploaded files
 * Handles both relative and absolute URLs
 */
export const getMediaUrl = (path) => {
  if (!path) return null;

  // If already a full URL (starts with http:// or https://), return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }

  // Get API base URL from environment or default
  const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

  // Remove /api from API_BASE_URL if present (for media files)
  const baseUrl = API_BASE_URL.replace('/api', '');

  // If path starts with /, use it directly
  if (path.startsWith('/')) {
    return `${baseUrl}${path}`;
  }

  // Otherwise, add /media/ prefix
  return `${baseUrl}/media/${path}`;
};